<template>
  <span>
    <span v-for="ref, index in refs" v-bind:key="index">
      <component v-if="ref.component" :is="ref.component" v-bind="ref.props"></component>
      <span v-else>{{ ref }}</span>
    </span>
  </span>
</template>

<script>

  /**
   * Get the desc of the bicrefs has the following format:
   * bicrefs: 
   *  desc: text0 #$0 text1 #$1 text2 ....
   *  refs:
   *    0:  { id: ...  , type: ... , desc: ... }
   *    1:  { id: ...  , type: ... , desc: ... }
   * 
   * this component will split the desc and build an array with the following format[
   * { text: text0, link: refs[0] }
   * { text: text1, link: refs[1] }
   * { text: text2, link: null }
   * ]
   * The link will then be processed as a route or a simple link (if type === class)
   * 
   */
  
  import Vue from 'vue';
  import BicItemRefLink from './BicItemRefLink.vue';
  import router from '../router/index.js';

  export default Vue.component('BicItemRefSplit', {
    props: {
      bicref: Object,
      getAlternateBicForSource: Function,
    },
    computed: {
      refs: function() {
        const parts = this.splitText(this.bicref.desc);
        return this.mergeRefs(parts, this.bicref.refs);
      },
    },
    methods: {
      // transforms the description to an array
      // eg: "You can also use #$0 or #$1 or somethihg else." becomes ["You can also use ", "#$0", " or ", "#$1", " or somethihg else."]
      splitText: function(text) {
        if (text) {
          return text.split(/(\#\$\d+)/gi).filter((item) => (item));  
        }
        return [];
      },
      // takes an array with $#n tokens and replaced them with components
      // eg: "You can also use #$0 or #$1 or somethihg else." becomes ["You can also use ", "#$0", " or ", "#$1", " or somethihg else."]
      mergeRefs: function(parts, refs) {
        return parts.map((part) => {
          const tokenMatch = part.match(/(?:\#\$)([0-9]+)/i);
          if (tokenMatch && refs && refs[tokenMatch[1]]) {
            return { component: BicItemRefLink, props: { bicref: refs[tokenMatch[1]], click: this.getAlternateBicForSource } };
          }
          return part;
        });
      }
    }
  });
</script>